<div
	class="pet-information"
	role="presentation"
>
	<section class="pet-information__content">
		<ng-container *ngTemplateOutlet="content"></ng-container>
	</section>
</div>

<ng-template #content>
	<section
		*ngIf="quoteRetrievalError"
		class="pet-information__retrieve-error"
	>
		<button
			class="pet-information__retrieve-error-dismiss"
			(click)="quoteRetrievalError = !quoteRetrievalError"
		>
			<svg
				class="pet-information__retrieve-error-dismiss-icon" 
				viewBox="0 0 48 48" 
				fill="none" 
				xmlns="http://www.w3.org/2000/svg">
				<rect width="20.365" height="2.263" rx="1" transform="rotate(-45 44.696 -4.114)" fill="currentColor"/>
				<rect width="20.365" height="2.263" rx="1" transform="rotate(45 -10.514 29.245)" fill="currentColor"/>
			</svg>
		</button>
		<p class="pet-information__retrieve-error-heading">
			<epi-icon
				use="error"
				color="warn"
				[size]="24"
				class="pet-information__retrieve-error-heading-icon"
			></epi-icon>
			Oh no! We couldn't retrieve your quote.
		</p>
		<section class="pet-information__retrieve-error-content">
			<p class="pet-information__retrieve-error-message">
				No worries, it's super fast to get a new one. Literally seconds.
			</p>
			<p class="pet-information__retrieve-error-message">
				Or call us at {{ brandPhoneNumber$ | async }} and a Pet Insurance
				Advisor can help retrieve your quote.
			</p>
		</section>
	</section>
	<qe-content-section [bordered]="false" [rounded]="true" class="pet-information__wrapper">
		<h1 class="pet-information__heading c-heading c-heading--level-1"
		
		
		>
			Your Customized Quote in Seconds
		</h1>
		<epi-hint class="pet-information__hint">
			Tell us about your pet below to get a personalized quote in under 30 seconds.
		</epi-hint>
		<ng-container [ngTemplateOutlet]="petInformationFormTemplate"></ng-container>
	</qe-content-section>
	<qe-content-section *ngIf="showEmployerForm">
		<h2 class="c-heading c-heading--as-1 c-heading--color-primary"
	
		
		>
			Employer Information
		</h2>
		<form
			[formGroup]="employerForm"
			class="pet-information__employer"
		>
			<div
				class="u-row"
				role="presentation"
			>
				<div
					class="u-row__column m--tablet-6 u-margin-top-medium"
					role="presentation"
				>
					<epi-input input-id="employerName">
						<span slot="label">Employer Name</span>
						<input
							#employerNameEl
							formControlName="name"
							placeholder="Enter Employer Name"
							slot="epiInput"
							type="search"
							autocomplete="new-password"
							data-quat="input_employerName"
						/>
					</epi-input>
					<epi-validation-error *ngIf="
							employerName?.errors?.required &&
							(employerName?.touched || formInvalid)
						">
						Please enter the name of your employer.
					</epi-validation-error>
				</div>
			</div>
			<div
				class="u-row"
				role="presentation"
			>
				<div
					class="u-row__column m--tablet-6 u-margin-top-medium"
					role="presentation"
				>
					<epi-input input-id="employerStreetAddress">
						<span slot="label">Street Address</span>
						<input
							formControlName="address"
							slot="epiInput"
							type="text"
							data-quat="input_employerAddress"
						/>
					</epi-input>
					<epi-validation-error *ngIf="
							employerAddress?.errors?.required &&
							(employerAddress?.touched || formInvalid)
						">
						Please enter your employer's address.
					</epi-validation-error>
				</div>
			</div>
			<div
				class="u-row"
				role="presentation"
			>
				<div
					class="u-row__column m--tablet-6 u-margin-top-medium"
					role="presentation"
				>
					<epi-input input-id="employerCity">
						<span slot="label">City</span>
						<input
							formControlName="city"
							slot="epiInput"
							type="text"
							data-quat="input_employerCity"
						/>
					</epi-input>
					<epi-validation-error *ngIf="
							employerCity?.errors?.required &&
							(employerCity?.touched || formInvalid)
						">
						Please enter your employer's city.
					</epi-validation-error>
				</div>
			</div>
			<div
				class="u-row"
				role="presentation"
			>
				<div
					class="u-row__column m--tablet-3 u-margin-top-medium"
					role="presentation"
				>
					<epi-select
						qeCustomInput
						formControlName="state"
						data-quat="input_employerState"
					>
						<span slot="label">State</span>
						<epi-option
							*ngFor="let state of stateList; let i = index"
							[value]="state.abbreviation"
							id="employerStateOption{{ i }}"
							slot="option"
							attr.data-quat="input_employerState{{ i }}"
						>
							{{ state.abbreviation }} - {{ state.name }}
						</epi-option>
					</epi-select>
					<epi-validation-error *ngIf="
							employerState?.errors?.required &&
							(employerState?.touched || formInvalid)
						">
						Please select your employer's state.
					</epi-validation-error>
				</div>
				<div
					class="u-row__column m--tablet-3 u-margin-top-medium"
					role="presentation"
				>
					<epi-input input-id="employerZipCode">
						<span slot="label">Zip Code</span>
						<input
							formControlName="zipCode"
							slot="epiInput"
							type="text"
							data-quat="input_employerZipCode"
						/>
					</epi-input>
					<epi-validation-error *ngIf="
							employerZipCode?.errors?.required &&
							(employerZipCode?.touched || formInvalid)
						">
						Please enter your employer's zip code.
					</epi-validation-error>
				</div>
			</div>
			<div
				role="presentation"
				class="u-row u-margin-top-small"
			>
				<div
					role="presentation"
					class="u-row__column u-margin-top"
				>
					<ng-container *ngTemplateOutlet="submitButton"></ng-container>
				</div>
			</div>
		</form>
	</qe-content-section>
	<qe-content-section *ngIf="showAgentForm">
		<h2 class="c-heading c-heading--as-1 c-heading--color-primary"
	
		
		>
			Agent Information
		</h2>
		<form [formGroup]="agentForm">
			<div
				class="u-row"
				role="presentation"
			>
				<div
					class="u-row__column m--tablet-4 u-margin-top-medium"
					role="presentation"
				>
					<epi-input input-id="partnerSenderId">
						<span slot="label">
							Agent ID
							<epi-tooltip>
								Agent ID is required. Your Agent ID can be found on your
								Embrace Pet Insurance Contact sheet.
							</epi-tooltip>
						</span>
						<input
							formControlName="partnerSenderId"
							slot="epiInput"
							type="text"
							data-quat="input_partnerSenderId"
						/>
					</epi-input>
					<epi-validation-error *ngIf="
							partnerSenderId?.errors?.required &&
							(partnerSenderId?.touched || formInvalid)
						">
						Please enter your agent ID.
					</epi-validation-error>
				</div>
			</div>
			<div
				role="presentation"
				class="u-row u-margin-top-medium"
			>
				<div
					role="presentation"
					class="u-row__column u-margin-top"
				>
					<ng-container *ngTemplateOutlet="submitButton"></ng-container>
				</div>
			</div>
		</form>
	</qe-content-section>
</ng-template>

<ng-template #submitButton>
	<section>
		<div
			class="u-row c-form-input u-margin-bottom-small"
			role="presentation"
		>
			<ng-container>
				<epi-hint>
					By clicking '{{ submitButtonLabel }}', I am providing my E-SIGN signature authorizing Embrace Pet Insurance, or others on Embrace's behalf to contact me via email, phone or SMS. These communications may include automated dialers or prerecorded voice messages. Standard message and data rates may apply. Reply STOP to opt out. Enrollment in phone or SMS communications is not required to get a quote.
				</epi-hint>
			</ng-container>
		</div>
		<epi-validation-error
			*ngIf="formInvalid"
			class="u-margin-bottom-small u-margin-top-small"
			gtm-id="error_incomplete-pet_info-incomplete_form"
		>
			Please complete all required fields before continuing.
		</epi-validation-error>
		<epi-validation-error
			*ngIf="policyHolderExists"
			class="u-margin-bottom-small u-margin-top-small error-policy-holder"
			gtm-id="error_api-pet_info-existing_policy_holder"
		>
			<span>Oops, it looks like you're already an existing policy holder! Please visit your customer portal to <a [href]="myEmbraceUrlChangeCoverage" target="_blank">change coverage</a> or <a  [href]="myEmbraceUrlAddAPet" target="_blank">add a pet</a>. For anything else, please call us at 800-383-9088.</span>
		</epi-validation-error>
		<ng-container *ngIf="ruleError">
			<epi-validation-error
				*ngFor="let error of ruleErrorList"
				class="u-margin-bottom-small"
				[attr.gtm-id]="'error_api-pet_info-' + error"
			>
				{{ error }}
			</epi-validation-error>
		</ng-container>
		<span>
			<button
				qeBaseButton
				type="submit"
				(click)="submitForm()"
				data-quat="action_startQuote"
				[disabled]="submittingForm"
			>
				{{ submitButtonLabel }}
			</button>
			<p class="reassurance-text">No commitment. Just your price.</p>
		</span>
	</section>
</ng-template>

<ng-template #petInformationFormTemplate>
	<form [formGroup]="petInformationForm">
	<section class="add-pet-form">
		<div role="presentation">
			<div
				class="u-row c-form-input u-margin-bottom-small"
				role="presentation"
			>
				<epi-input input-id="petName">
					<div class="form_input" slot="epiInput">
						<label
							class="form_input-label"
							[class.focused]="petNameFocused() || petName?.value"
							for="petName"
						>
							Pet's Name*
						</label>
						<input
							id="petName"
							class="form_input-input"
							formControlName="petName"
							slot="epiInput"
							name="petName"
							type="text"
							maxlength="100"
							(focus)="onFocus('petName')"
							(blur)="onBlur('petName')"
							data-quat="input_petName"
							placeholder="Enter your pet's name"
						/>
					</div>
					<epi-validation-error
						*ngIf="petName?.hasError('required') && petName?.touched"
						data-quat="alert_petNameValidation"
						gtm-id="error_form-field_pet-name_required"
					>Please enter your pet's name.</epi-validation-error>
					<epi-validation-error
						*ngIf="petName?.hasError('pattern') && petName?.touched"
						gtm-id="error_form-field_pet-name_invalid"
					>
						Your pet's name must start with a letter or number and may not
						contain special characters.
					</epi-validation-error>
					<epi-validation-error
						*ngIf="petName?.hasError('maxLength') &&
							petName?.touched"
							gtm-id="error_form-field_pet-name_max-length"
						>
						Your pet's name may not be longer than 100 characters.
					</epi-validation-error>
				</epi-input>
			</div>
			<div class="u-row u-margin-bottom-small breed-toggles__row">
				<div class="c-form-input toggle-wrapper">
					<qe-toggle-option
						[options]="speciesOptions"
						[brand]="formattedBrand"
						[iconTemplates]="{ dog: dogIcon, cat: catIcon }"
						formControlName="species"
						name="pet-species"
						ariaLabel="Select pet species"
						id="pet-species-toggle"
						label="Your pet's species*"
						(selectionChange)="onRadioChange('pet_species', $event.value)"
					>
						<ng-template #dogIcon let-selected="selected">
							<qe-dog-icon
								[backgroundColor]="selected ? 'var(--white)' : 'var(--bodyBackground)'"
								[strokeColor]="selected ? 'var(--white)' : 'var(--typographyColor)'"
							></qe-dog-icon>
						</ng-template>
						<ng-template #catIcon let-selected="selected">
							<qe-cat-icon
								[backgroundColor]="selected ? 'var(--white)' : 'var(--bodyBackground)'"
								[strokeColor]="selected ? 'var(--white)' : 'var(--typographyColor)'"
							></qe-cat-icon>
						</ng-template>
					</qe-toggle-option>
					<epi-validation-error
						*ngIf="species?.invalid && (formInvalid || species?.touched)"
						gtm-id="error_form-field_pet-species_required"
					>
						Please select your pet's species.
					</epi-validation-error>
				</div>
				<div class="toggle-wrapper">
					<qe-toggle-option
						[options]="sexOptions"
						[brand]="formattedBrand"
						[iconTemplates]="{ male: maleIcon, female: femaleIcon }"
						formControlName="sex"
						name="pet-sex"
						ariaLabel="Select pet sex"
						id="pet-sex-toggle"
						(selectionChange)="onRadioChange('pet_sex', $event.value)"
						label="Your pet's sex*"
					>
						<ng-template #femaleIcon let-selected="selected">
							<qe-female-icon
								[backgroundColor]="selected ? 'var(--white)' : 'var(--bodyBackground)'"
								[strokeColor]="selected ? '' : 'var(--typographyColor)'"
							></qe-female-icon>
						</ng-template>
						<ng-template #maleIcon let-selected="selected">
							<qe-male-icon
								[backgroundColor]="selected ? 'var(--white)' : 'var(--bodyBackground)'"
							[strokeColor]="selected ? '' : 'var(--typographyColor)'"
						></qe-male-icon>
						</ng-template>
					</qe-toggle-option>
					<epi-validation-error
						*ngIf="sex?.invalid && (formInvalid || sex?.touched)"
						gtm-id="error_form-field_pet-sex_required"
					>
						Please select your pet's sex.
					</epi-validation-error>
				</div>
			</div>
			<div
				class="u-row c-form-input u-margin-bottom-small"
				role="presentation"
			>
				<qe-combobox
					#breedDropdownEl
					qeCustomInput
					[disabled]="!species?.value"
					[formGroup]="petInformationForm"
					inputId="breed"
					data-quat="input_breed"
					[options]="breedsList"
					label="Your Pet's Breed"
					type="breed"
					placeholder="Search breeds"
				></qe-combobox>
				<qe-tooltip tooltip-id="pet-information-email-tooltip" triggerAction="click">
					<p text-trigger class="breed-tooltip">Unsure of your pet's breed?</p>
					<div content>
						<p class="m--bold">Pick the closest match if you have a guess.</p>
						<p>Know one breed in the mix? Try options like "Boxer mix"</p>
						<p>Totally unsure? Type "Mixed Breed" and select their size.</p>
					</div>
				</qe-tooltip>
				<epi-validation-error
					*ngIf="breed?.invalid && breed?.touched"
					gtm-id="error_form-field_pet-breed_required"
				>
					Please select your pet's breed.
				</epi-validation-error>
			</div>
			<div class="u-row c-form-input u-margin-bottom-small">
				<qe-shared-select
					#ageInputEl
					data-quat="input_age"
					id="age"
					type="age"
					[formGroup]="petInformationForm"
					placeholder="Select your pet's age"
				>
				</qe-shared-select>
				<epi-validation-error
					*ngIf="age?.invalid && age?.touched"
					gtm-id="error_form-field_pet-age_required"
				>
					Please select your pet's age.
				</epi-validation-error>
			</div>
			<div
				*ngIf="serviceDogEnabled && species?.value === 'dog'"
				class="u-row u-margin-bottom-small c-form-input"
				role="presentation"
			>
				<qe-toggle-option
					[options]="serviceDogOptions"
					[brand]="formattedBrand"
					formControlName="serviceDog"
					name="pet-service-dog"
					ariaLabel="Select if your dog is a service animal"
					id="service-dog-toggle"
					(selectionChange)="onRadioChange('service_dog', $event.value)"
					label="Is your dog a service dog?"
				></qe-toggle-option>
				<epi-validation-error
					*ngIf="serviceDog?.invalid && serviceDog?.touched"
					gtm-id="error_form-field_pet-service-dog_required"
				>
					Please specify if your dog is a service animal.
				</epi-validation-error>
				<div class="service-dog-disclaimer" *ngIf="serviceDog?.value === 'yes'">
					<img src="../../../assets/icons/exclamation-circle.png" alt="Service Dog" />
					<p>We are able to offer a 5% discount for service dogs that are trained to mitigate the symptoms or effects of their owners' disability.
						Currently, we cannot provide a discount for emotional support animals or therapy dogs. May not apply in all states.
					</p>
				</div>
			</div>
		</div>
		</section>
		<div
			class="u-row toggle-col u-margin-bottom-small additional-pets__row"
			role="presentation"
		>
			<qe-toggle-option
				[options]="additionalPetsOptions"
				[brand]="formattedBrand"
				formControlName="additionalPets"
				name="additional-pets"
				id="additonal-pets-toggle"
				ariaLabel="Select if you have more than one pet in the household"
				(selectionChange)="onRadioChange('additional_pets', $event.value)"
				label="Do you have more than one cat or dog?*"
			></qe-toggle-option>
			<epi-validation-error
				*ngIf="addtionalPetsControl?.invalid && addtionalPetsControl?.touched"
				gtm-id="error_form-field_pet-species_required"
			>
				Please select one of the options above.
			</epi-validation-error>
				<div class="additional-pets__message" [ngClass]="{ 'additional-pets__message--visible': additionalPets }">
					<p>🎉 <span class="additional-pets__message--bold">Good news!</span>  You can add more pets later to ensure the whole family's covered. Plus, you'll save 10%!</p>
				</div>
		</div>
		<div
			class="u-row c-form-input u-margin-bottom-small"
			role="presentation"
		>
			<epi-input
				input-id="zipCode"
				[invalid]="zipCode?.invalid && zipCode?.dirty"
				#zipCodeEl
			>
				<div class="form_input">
					<label
						class="form_input-label"
						[class.focused]="focusedInput === 'zipCode' || zipCode?.value"
						for="zipCode"
					>
						Zip Code*
					</label>
					<input
						id="zipCode"
						class="form_input-input"
						formControlName="zipCode"
						slot="epiInput"
						type="text"
						name="zipCode"
						inputmode="numeric"
						minlength="5"
						maxlength="5"
						(focus)="onFocus('zipCode')"
						(blur)="onBlur('zipCode')"
						data-quat="input_zipCode"
						placeholder="Enter zip code"
					/>
				</div>
			</epi-input>
			<epi-hint>*Where you and your pet reside</epi-hint>
			<epi-validation-error
					*ngIf="
						zipCode?.errors?.required && (zipCode?.touched || formInvalid)
					"
					data-quat="alert_zipCodeValidation"
					gtm-id="error_form-field_zip-code_required"
				>
					Please enter your zip code of residence.
			</epi-validation-error>
			<epi-validation-error *ngIf="
					zipCode?.errors?.pattern && (zipCode?.touched || formInvalid)
				"
				gtm-id="error_form-field_zip-code_invalid"
				>
				Zip code may only contain digits.
			</epi-validation-error>
			<epi-validation-error
				*ngIf="
					(zipCode?.errors?.minlength || zipCode?.errors?.maxlength) &&
					(zipCode?.touched || formInvalid)
				"
				gtm-id="error_form-field_zip-code_min-length"
			>
				Zip code must be 5 digits long.
			</epi-validation-error>
		</div>
		<div class="c-form-input u-row u-margin-bottom-small">
				<epi-input
					input-id="emailAddress"
					[invalid]="emailAddress?.invalid && emailAddress?.dirty"
					#emailAddressEl
				>
					<div class="form_input">
						<label
							class="form_input-label"
							[class.focused]="focusedInput === 'emailAddress' || emailAddress?.value"
							for="emailAddress"
						>
							Email Address*
						</label>
						<input
							id="emailAddress"
							class="form_input-input"
							formControlName="emailAddress"
							type="text"
							name="emailAddress"
							inputmode="email"
							slot="epiInput"
							(focus)="onFocus('emailAddress')"
							(blur)="onBlur('emailAddress')"
							data-quat="input_emailAddress"
							placeholder="Enter email"
						/>
					</div>

				</epi-input>
				<div class="email-tooltip form-text-tooltip">
					<qe-tooltip tooltip-id="pet-information-email-tooltip" triggerAction="click">
						<p text-trigger>How do we use your email?</p>
						<div content>
							<p class="m--bold">Why we ask for your email:</p>
							<p>We use it to save your quote and send you a secure link so you can finish later. You can unsubscribe from emails anytime.</p>
						</div>
					</qe-tooltip>
				</div>
					<epi-validation-error
						*ngIf="
							emailAddress?.errors?.required &&
							(emailAddress?.touched || formInvalid)
						"
						data-quat="alert_emailAddressValidation"
						gtm-id="error_form-field_email_required"
					>
						Please enter your email address.
					</epi-validation-error>
					<epi-validation-error
						*ngIf="
							emailAddress?.errors?.email &&
							(emailAddress?.touched || formInvalid)
						"
						data-quat="alert_emailAddressValidation"
						gtm-id="error_form-field_email_invalid"
					>
						Please enter a valid email address.
					</epi-validation-error>
		</div>
		<div
			class="u-row c-form-input u-margin-bottom-small"
			role="presentation"
		>
			<epi-input input-id="phoneNumber">
				<div class="form_input">
					<label
						class="form_input-label"
						[class.focused]="focusedInput === 'phoneNumber' || phoneNumber?.value"
						for="phoneNumber"
					>
						<ng-container *expEvaluate="{ layer: 'page_1_experiments', variation: ['default', 'control', 'not_targeted'] }">
							Phone Number (Optional)
						</ng-container>
						<ng-container *expEvaluate="{ layer: 'page_1_experiments', variation: 'qe-1-nb-2696_page-1-optional-phone-hidden' }">
							Phone Number
						</ng-container>
						
					</label>
					<input
						id="phoneNumber"
						class="form_input-input"
						qeInputMask="phone"
						formControlName="phoneNumber"
						type="text"
						inputmode="tel"
						slot="epiInput"
						data-quat="input_phoneNumber"
						(focus)="onFocus('phoneNumber')"
						(blur)="checkPhoneNumber()"
						placeholder="Enter phone number"
					/>
				</div>
			</epi-input>
			<epi-validation-error
				*ngIf="
					phoneNumber?.errors?.minlength &&
					phoneNumber?.dirty &&
					phoneNumber?.value?.length
				"
				gtm-id="error_form-field_phone-number_min-length"
			>
				Your phone number must be 10 digits long.
			</epi-validation-error>
			<!-- <div class="u-row__column m--tablet-6 sms-checkbox-container" *ngIf="!isModernLinkBrand()">
				<epi-checkbox
					qeEpiControl
					formControlName="optInTextMessage"
					input-id="optInTextMessage"
					input-name="optInTextMessage"
					data-quat="input_optInTextMessage"
					#optInTextMessageCheckbox
					(epiCheckChanged)="handleOptInTextMessageCheckbox(optInTextMessageCheckbox)">
					Sign up for SMS notifications
				</epi-checkbox>
			</div> -->
		</div>
		<div class="u-row c-form-input u-margin-bottom-small" role="presentation" *ngIf="optInTextMessage?.value && phoneNumber?.value">
			<div class="u-row__column">
				<epi-hint class ="sms-opt-in-disclaimer">
					By entering my mobile number and checking this box I agree to Opt in to receive
					important messages from Embrace Pet Insurance regarding my pet insurance quote,
					helpful tips, and general information about our products and services. Msg frq
					varies Text HELP to 98632 for help, Text STOP to 98632 to end. Msg&Data Rates May
					Apply. By opting in, I authorize Embrace Pet Insurance to deliver SMS messages
					using an automatic telephone dialing system and I understand that I am not required
					to opt in as a condition of purchasing any property, goods, or services. By leaving
					this box unchecked you will not be opted in for SMS messages at this time. Click to
					read <a
					qeBaseLink
					target="blank"
					[href]="smsTermsAndConditionsUrl"
					class="footer__links-item n--minimal"
					data-quat="action_smsTermsAndConditionsLink"
				>Terms & Conditions</a> & <a
					qeBaseLink
					size="small"
					[href]="privacyPolicyUrl"
					target="_blank"
					class="n--minimal"
					data-quat="action_smsPrivacyPolicyLink"
				>
					Privacy Policy
				</a>.
				</epi-hint>
			</div>
		</div>
		<div
			*ngIf="!showEmployerForm && !showAgentForm"
			class="u-row"
			role="presentation"
		>
			<div
				class="u-row__column submit-actions"
				role="presentation"
			>
				<ng-container *ngTemplateOutlet="submitButton"></ng-container>
			</div>
		</div>
	</form>
</ng-template>
